import React from "react";
import logo from "../assets/logo.png";
import {
  AiOutlineTwitter,
  AiFillFacebook,
  AiOutlineWhatsApp,
  AiOutlineInstagram,
} from "react-icons/ai";

function Footer() {
  return (
    <div className="footer py-20">
      <div className="container">
        <div className="row -mx-4">
          <div className="footer-logo-col w-full sm:w-6/12 md:w-4/12 p-4">
            <a href="#" className="inline-block w-[120px] h-auto ">
              <img src={logo} alt="" className="w-full h-full object-cover" />
            </a>
            <p className=" mt-3 text-base xl:w-8/12">
              Copyright &copy; 2022 by Mark Antony. All rights reserved.
            </p>
            <ul className="mt-3 flex gap-3">
              <a href="#">
                <AiOutlineTwitter className="text-orange-600" />
              </a>
              <a href="#">
                <AiOutlineInstagram className="text-orange-600" />
              </a>
              <a href="#">
                <AiOutlineWhatsApp className="text-orange-600" />
              </a>
              <a href="#">
                <AiFillFacebook className="text-orange-600 text-xl" />
              </a>
            </ul>
          </div>

          <div className="footer-col w-6/12 sm:w-3/12 md:w-4/12 lg:w-2/12 p-4">
            <h1 className="footer-heading text-lg font-semibold capitalize">
              services
            </h1>
            <ul className="mt-3">
              <li>
                <a
                  href=""
                  className="block footer-ul-li-a text-base text-gray-500 capitalize mt-5 "
                >
                  online order
                </a>
              </li>
              <li>
                <a href="" className="footer-ul-li-a">
                  online order
                </a>
              </li>
              <li>
                <a href="" className="footer-ul-li-a">
                  online order
                </a>
              </li>
              <li>
                <a href="" className="footer-ul-li-a">
                  online order
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col w-6/12 sm:w-3/12 md:w-4/12 lg:w-2/12 p-4">
            <h1 className="footer-heading text-lg font-semibold capitalize">
              services
            </h1>
            <ul className="mt-3">
              <li>
                <a
                  href=""
                  className="block footer-ul-li-a text-base text-gray-500 capitalize mt-5 "
                >
                  online order
                </a>
              </li>
              <li>
                <a href="" className="footer-ul-li-a">
                  online order
                </a>
              </li>
              <li>
                <a href="" className="footer-ul-li-a">
                  online order
                </a>
              </li>
              <li>
                <a href="" className="footer-ul-li-a">
                  online order
                </a>
              </li>
            </ul>
          </div>

          {/*end*/}
        </div>
      </div>
    </div>
  );
}

export default Footer;
